import { config } from '@/config';
import { LINKS } from '@/constants';
import { dateToTimeStamp } from '@/helpers/time';
import { apiCaller } from '@/redux/query';
import { isSkipApiSelector } from '@/redux/slice/auth.slice';
import { dashboardDataSelector } from '@/redux/slice/dashboard.slice';
import { Modal, Text } from '@shopify/polaris';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

interface IProps {
  defaultOpen?: boolean;
}

const CLICK_THRESHOLD = 20;

const ModalReview = ({ defaultOpen = false }: IProps) => {
  const [open, setOpen] = useState(!!defaultOpen);
  const dashboard = useSelector(dashboardDataSelector);
  const isSkip = useSelector(isSkipApiSelector);
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null);
  const { data } = apiCaller.useGetDataSummaryQuery(
    {
      startTime: dateToTimeStamp(dashboard.startDate),
      endTime: dateToTimeStamp(dashboard.endDate),
    },
    { skip: isSkip },
  );

  const isShow = (data?.data?.summary?.clicks || 0) >= CLICK_THRESHOLD;

  const cacheKey = `chat_wix_review_${config?.shop || ''}`;

  useEffect(() => {
    const isShowedReview = localStorage.getItem(cacheKey);
    if (isShowedReview === 'true') {
      return;
    }
    if (isShow) {
      timeoutIdRef.current = setTimeout(() => {
        setOpen(true);
        localStorage.setItem(cacheKey, 'true');
      }, 1000);
    }
    return () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
    };
  }, [cacheKey, isShow]);

  return (
    <Modal title="" titleHidden open={open} onClose={() => setOpen(false)}>
      <Modal.Section>
        <Text alignment="center" as="h3" variant="headingMd">
          Hurray! You have used Omega WhatsApp & Contact Form!
        </Text>
        <div className="mt-8">
          <iframe
            src={LINKS.WIX_REVIEW}
            title="Review blockify app iframe"
            width="100%"
            height="570px"
            style={{ border: '1px solid #E0E0E0', borderRadius: '12px' }}
          ></iframe>
        </div>
      </Modal.Section>
    </Modal>
  );
};

export default ModalReview;
